import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SITE_PATHS from '../../../config/sitePaths';
import CompanyLogo from '../../../components/CompanyLogo';
import formatCurrency from '../../../utils/formatCurrency';
import Text from '../../../components/Text';

const processBalance = (balance) => (balance ? formatCurrency(balance) : '');

const viewDetails = (history, scoringRequest) => history
  .push(SITE_PATHS.LOAN, { scoringRequest });

const loanItem = ({ history, scoringRequest }) => (
  <button
    className="loanListItemContainer"
    onClick={() => viewDetails(history, scoringRequest)}
    type="button"
  >
    <div className="loanItem card rounded d-flex flex-row flex-wrap align-items-center">
      <div className="d-flex align-items-center">
        <CompanyLogo
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...scoringRequest}
          size="small"
        />
      </div>
      <div className="card-body">
        <span className="companyTitle">
          {scoringRequest.companyDisplayName}
        </span>
        <div className="w-100" />
        <span className="loanBalance">
          <Text value="currencySymbol" />
          {processBalance(scoringRequest.balance)}
        </span>
        <div className="w-100" />
        <span className="loanDate">
          {(scoringRequest.dateOriginated || scoringRequest.dateApplied)}
        </span>
        <span className="loanStatus">
          <Text value={scoringRequest.status} />
        </span>
      </div>
      <div className="loanArrow ml-auto flex-row-reverse align-items-center">
        <FontAwesomeIcon icon="chevron-circle-right" size="2x" color="black" />
      </div>
    </div>
  </button>
);

export default loanItem;
